<div class="business-dialog-container">
    <div class="dialog-header">
        <h3 class="dialog-title">Refer a Vendor</h3>
        <button mat-icon-button class="close-btn" (click)="closeDialog()" tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="form-body">
        <p class="intro-text">Know a great vendor? Share their details below and we will contact them to join.</p>

        <form [formGroup]="referForm" (ngSubmit)="submitReferral()" class="form">
            
            <h4 class="section-heading mt-0">Your Details</h4>
            <div class="form-row mb-12">
                <div class="custom-input-box half-width" [class.disabled-box]="true">
                    <input type="text" formControlName="customerName" placeholder="Your Name" />
                </div>
                <div class="custom-input-box half-width hide-small" [class.disabled-box]="true">
                    <input type="email" formControlName="customerEmail" placeholder="Your Email" />
                </div>
                <div class="custom-input-box half-width" [class.disabled-box]="true">
                    <input type="tel" formControlName="customerPhone" placeholder="Your Phone" />
                </div>
            </div>
            
            <div class="divider"></div>

            <div class="section-header-row">
                <h4 class="section-heading">Vendor Details</h4>
                <button type="button" class="btn-add-vendor" (click)="addVendor()">+ Add Vendor</button>
            </div>

            <div formArrayName="vendors">
                <div *ngFor="let vendorCtrl of vendors.controls; let i = index" [formGroupName]="i" class="vendor-card">
                    <div class="vendor-card-header" *ngIf="vendors.length > 1">
                        <h4>Vendor {{ i + 1 }}</h4>
                        <button type="button" mat-icon-button class="btn-remove" (click)="removeVendor(i)" title="Remove Vendor">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>

                    <div class="form-row">
                        <div class="custom-input-box half-width" [class.has-error]="vendorCtrl.get('vendorName')?.touched && vendorCtrl.get('vendorName')?.invalid">
                            <input type="text" formControlName="vendorName" placeholder="Company or Name *" />
                        </div>
                        <div class="custom-input-box half-width hide-small" [class.has-error]="vendorCtrl.get('vendorEmail')?.touched && vendorCtrl.get('vendorEmail')?.invalid">
                            <input type="email" formControlName="vendorEmail" placeholder="Email (Optional)" />
                        </div>
                        <div class="custom-input-box half-width" [class.has-error]="vendorCtrl.get('vendorPhone')?.touched && vendorCtrl.get('vendorPhone')?.invalid">
                            <input type="tel" formControlName="vendorPhone" placeholder="Phone *" />
                        </div>
                    </div>
                </div>
            </div>

            <button class="primary-cta" type="submit" [disabled]="isSubmitting">
                <mat-spinner *ngIf="isSubmitting" diameter="20" class="btn-spinner"></mat-spinner>
                Submit
            </button>
        </form>
    </div>
</div>
